<template>
    <div class='t_content_view'>
         <!-- 标题 -->
         <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>基础信息</div>
        </div>
        <div class="t_con_box_f" style="margin-top: 20px;">
            <div class="t_con_title_f" style="width: 94px;">任务名称：</div>
            <div style="font-size: 15px;line-height: 40px;">
                {{ itemdetail.data.taskName }}
            </div>
        </div>
        <div class="t_con_box_f" style="margin-top: 0px;">
            <div class="t_con_title_f" style="width: 94px;">选择扫码号：</div>
            <div style="font-size: 15px;line-height: 40px;">
                    <el-tooltip
                        v-if="itemdetail.data.userList.length < 6" v-for="(item, index) in itemdetail.data.userList" :key="index"
                        class="box-item"
                        effect="dark"
                        :content=item.name
                        placement="top">
                        <img 
                            style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                            :src="item.avatar" alt="">
                    </el-tooltip>
                    
                    <div class="t_more_img" v-else>
                        <div style="display: flex;" v-if="!checksmh">
                            <el-tooltip
                                v-for="(item, index2) in itemdetail.data.userList.slice(0, 5)" :key="index2"
                                class="box-item"
                                effect="dark"
                                :content=item.name
                                placement="top">
                                <img 
                                style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                                :src="item.avatar" alt="">
                            </el-tooltip>
                            <div >等{{ itemdetail.data.userList.length-1 }}个扫码号 <el-button @click="checksmh=true" type="text" style="margin-left: 10px;">查看</el-button></div>
                        </div>
                        <div v-else>
                            <el-tooltip
                                v-for="(item, index2) in itemdetail.data.userList" :key="index2"
                                class="box-item"
                                effect="dark"
                                :content=item.name
                                placement="top">
                                <img 
                                style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                                :src="item.avatar" alt="">
                            </el-tooltip>
                        </div>
                        
                    </div>
            </div>
        </div>
        <div class="t_con_box_f" style="margin-top: 0px;">
            <div class="t_con_title_f" style="width: 94px;">好友去重：</div>
            <div style="font-size: 15px;line-height: 40px;">
                <span v-if="itemdetail.data.isRepeat==1">是</span>
                <span v-if="itemdetail.data.isRepeat==0">否</span>
            </div>
        </div>
        <div class="t_con_box_f" style="margin-top: 0px;">
            <div class="t_con_title_f" style="width: 94px;">创建时间：</div>
            <div style="font-size: 15px;line-height: 40px;">
                {{ itemdetail.data.createTime }}
            </div>
        </div>
         <!-- line -->
         <div class="t_line"></div>
         <!-- 标题 -->
         <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>添加设置</div>
        </div>
        <div class="t_con_box_f" style="margin-top: 20px;">
            <div class="t_con_title_f" style="width: 94px;">加好友时间：</div>
            <div style="font-size: 15px;line-height: 40px;">
                {{ itemdetail.data.taskTime }}
            </div>
        </div>
        <div class="t_con_box_f" style="margin-top: 20px;">
            <div class="t_con_title_f" style="width: 94px;">验证信息：</div>
            <div style="font-size: 15px;line-height: 40px;" >
                <div v-for='(item,index) in itemdetail.data.messageList' :key="index">
                    第{{index+1}}组:
                    {{ item.content }}
                </div>
               
            </div>
        </div>
        
         <!-- line -->
         <div class="t_line"></div>
         <!-- 标题 -->
         <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>添加设置</div>
        </div>
        <div class="t_con_box_f" style="margin-top: 20px;">
            <div class="t_con_title_f" style="width: 94px;">打标签：</div>
            <div style="font-size: 15px;line-height: 40px;" v-if='itemdetail.data.tagList!=null'>
                <div>共{{itemdetail.data.tagList.length}}个标签<el-button @click="checkbq=true" style="margin-left: 10px;" type="text">查看</el-button></div>
                <div v-if="checkbq">
                    <el-tag style="margin-right:10px" v-for="(item,index) in itemdetail.data.tagList" :key="index" type="success">{{ item.title }}</el-tag>
                </div>
            </div>
            <div style="font-size: 15px;line-height: 40px;" v-else>
                <div>共0个标签</div>
            </div>
        </div>
        <div class="t_con_box_f" style="margin-top: 20px;">
            <div class="t_con_title_f" style="width: 94px;">欢迎语：</div>
            <div style="font-size: 15px;line-height: 40px;" v-if="itemdetail.data.welcome!=null">
                <div>{{ itemdetail.data.welcome.title }}<el-button @click="checkhyy = true" style="margin-left: 10px;" type="text">查看</el-button></div>
                <div v-if="checkhyy">{{ itemdetail.data.welcome.text }}</div>
            </div>
            <div style="font-size: 15px;line-height: 40px;" v-else>
                无
            </div>
        </div>
    </div>
    
</template>

<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
//导入子组件

import { frienddetail } from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')

onMounted(() => {
    //获取详情数据
    getlist()
})

//数据
const itemdetail = reactive({
    data:{
        'welcome':{},
        'tagList':[],
        'messageList':[],
        'userList':[]
    }
})
//获取详情数据
const getlist = ()=>{
    frienddetail(_url2,{id:route.query.id}).then((response)=>{
        console.log('数据')
        console.log(response.data.result)
        itemdetail.data = response.data.result
    })
}
//查看所有扫码号
const checksmh = ref(false)
//查看所有标签
const checkbq = ref(false)
//欢迎语
const checkhyy = ref(false)


    


</script>

<style scoped>
.t_line{
    width: 100%;
    height: 1px;
    background-color: #DBDBDB;
    margin-top: 30px;
    margin-bottom: 30px;
}
.t_more_img {
    display: flex;
    flex-wrap: wrap;
}
.t_more {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    border: 1px solid white;
    border-radius: 50%;
    background-color: rgb(206, 206, 206);
    text-align: center;
    line-height: 30px;
}
</style>